module.exports = __webpack_public_path__ + "static/img/dfs_honor1.46241088.png";